

let initialState = [];

function eventDates(state = initialState, action) {
    if (action.type === "EVENTDATE_ADD") {
        return [].concat(state, [
            {  startDate: action.eventDate.startDate, 
                endDate: action.eventDate.endDate,
                 comment: action.eventDate.comment  }
        ])
    }
    if (action.type === "EVENTDATE_REMOVE" && action.eventDate.startDate  ) {
        return state.filter(eventDate => eventDate.startDate !== action.eventDate.startDate);
    }
    return state;
}

export default eventDates;